





















































import Vue from "vue";
import Error from "@/components/basic/Error.vue";
import { FieldInterface, ResponseError } from "@/types";
import { DELETE_ERROR, SET_SELECT_STATE } from "@/constants/mutation-types";
import { mapState } from "vuex";
import { UtilityHelper } from "@/helpers/UtilityHelper";
import ItemList from "@/components/basic/ItemList.vue";

export default Vue.extend({
  props: {
    itemList: Array, // FieldInterface[]
    placeholder: String,
    label: String,
    name: String,
    value: String,
    handlesDataPreload: {
      type: Boolean,
      default: true,
    },
    isValidated: {
      type: Boolean,
      default: true,
    },
    defaultValue: {
      default: null,
    },
    flags: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      MAX_SELECT_LIST_HEIGHT,
      id: "" as string,
      isExpanded: true as boolean,
      model: this.placeholder as string,
      isReverse: false,
      listHeight: 0,
      isOpen: false,
      isValid: false,
    };
  },

  beforeMount() {
    for (let i = 0; i < this.itemList.length; i++) {
      if ((this.itemList[i] as any).key === this.formDataStore[this.name]) {
        const index = i;
        const obj = this.itemList[i];

        this.itemList.splice(index, 1);
        this.itemList.unshift(obj);

        break;
      }
    }
  },

  mounted() {
    this.listHeight = ((this.$refs.itemList as any).$el as HTMLElement).getBoundingClientRect().height;
    this.isExpanded = false;

    document.addEventListener("click", this.closeSelectOnOutsideCLick);

    if (this.value && this.value.length > 0) {
      this.setValue(this.value);
    }

    if (this.defaultValue) {
      this.setValue(this.defaultValue as any);
    }

    if (this.handlesDataPreload) {
      this.loadData();
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeSelectOnOutsideCLick);
  },

  methods: {
    closeSelectOnOutsideCLick(evt: MouseEvent): void {
      const target: HTMLElement = evt.target as HTMLElement;

      if (!(this.$refs.customSelect as Node).contains(target)) {
        this.close();
      }
    },

    loadData(): void {
      /* load data from store to select component if store has name this same like select component*/
      if (this.formDataStore.hasOwnProperty(this.name) && null !== this.formDataStore[this.name]) {
        (this.itemList as FieldInterface[]).some((item: FieldInterface) => {
          let isFound = false;

          // tslint:disable-next-line: triple-equals
          if (item.key == this.formDataStore[this.name]) {
            this.setValue(item.key.toString());
            isFound = true;
          }
          return isFound;
        });
      }
    },

    async setValue(id: string): Promise<void> {
      if (Number.isNaN(Number(id as any))) {
        this.id = id;
      } else {
        this.id = Number(id).toString();
      }

      /* wait for itemList */
      await this.waitForItemList();
      /* end wait for itemList */

      (this.itemList as FieldInterface[]).some((item: FieldInterface) => {
        let isFound = false;
        // Has to be == not ===
        // tslint:disable-next-line:triple-equals
        if (item.key == id) {
          this.model = item.value;
          isFound = true;
        }

        return isFound;
      });

      if (this.isValidated) {
        this.$store.dispatch("validate", {
          name: this.name,
          value: this.id,
        });
      }

      this.$emit("input", this.id);
    },

    selectOption(item: FieldInterface): void {
      this.setValue(item.key.toString());
      this.close();
    },

    toggleSelect(): void {
      const ref = this.$refs.customSelect as HTMLElement;

      if (!this.willFitOnScreen()) {
        // place item list before input
        ref.insertBefore((this.$refs.itemList as any).$el as HTMLElement, ref.children[0]);
      } else {
        // place item list at the end of component
        ref.appendChild((this.$refs.itemList as any).$el as HTMLElement);
      }

      if (this.isExpanded) {
        this.close();
      } else {
        this.open();
      }
    },

    async open(): Promise<void> {
      this.$store.commit(SET_SELECT_STATE, false);

      await Vue.nextTick();

      this.isExpanded = true;
      this.$store.commit(SET_SELECT_STATE, this.isExpanded);
      this.$emit("focus");

      await UtilityHelper.sleep(5);
      this.listHeight = ((this.$refs.itemList as any).$el as HTMLElement).getBoundingClientRect().height;

      this.isOpen = true;
    },

    async close(): Promise<void> {
      this.isOpen = false;
      this.isExpanded = false;
      this.$emit("blur");
    },

    willFitOnScreen(): boolean {
      const boundaries = (this.$refs.customSelect as HTMLElement).getBoundingClientRect();
      const bodyBoundaries = document.body.getBoundingClientRect();

      this.isReverse = boundaries.bottom + this.MAX_SELECT_LIST_HEIGHT >= bodyBoundaries.bottom;

      return !this.isReverse;
    },

    waitForItemList(): Promise<CallableFunction> {
      return new Promise(resolved => {
        const interval = setInterval(() => {
          if (Array.isArray(this.itemList) && (this as any).itemList.length) {
            clearInterval(interval);
            resolved();
          }
        });
      });
    },
  },
  computed: {
    ...mapState({
      isSelectOpen(): boolean {
        return this.$store.state.isSelectOpen;
      },

      formDataStore(): any {
        return this.$store.state.formData;
      },

      hasError(): ResponseError {
        return this.$store.state.errors.get(this.name);
      },

      isValidFieldsChanged(): boolean {
        return this.$store.state.isValidFieldsChanged;
      },
    }),
  },
  watch: {
    isSelectOpen(newValue): void {
      if (!newValue) {
        this.isExpanded = false;
      }
    },

    isExpanded(): void {
      this.$store.commit(DELETE_ERROR, this.name);
    },

    model(): void {
      if (this.model.length >= 29) {
        const maxLengthString = this.model.slice(0, 29);
        const lastSpaceIndex = maxLengthString.lastIndexOf(" ");
        let result = this.model;

        if (lastSpaceIndex > -1) {
          result = maxLengthString.slice(0, lastSpaceIndex) + "...";
        } else {
          result = maxLengthString.slice(0, maxLengthString.length - 3) + "...";
        }

        this.model = `${result}`;
      }
    },

    value(newValue) {
      this.setValue(newValue);
    },

    isValidFieldsChanged(): void {
      this.isValid = this.$store.state.validFields.has(this.name);
    },
  },

  components: {
    Error,
    ItemList,
  },
});
const MAX_SELECT_LIST_HEIGHT = window.innerHeight < 500 ? 140 : 250;
